import createAuth0Client from '@auth0/auth0-spa-js';
import { EventEmitter } from '@osjs/event-emitter';

export class Login extends EventEmitter {
  /**
   * @param {Core} core Core reference
   * @param {Object} [options] Options
   */
  constructor(core, options) {
    super('Auth0Login');

    this.core = core;
    this.options = options;
  }

  /**
   * Initializes the UI
   */
  init(startHidden) {
    if (!window.auth0) {
      alert('Auth0 was not loaded. Unable to log in');
    }

    this.core.on('osjs/core:logged-out', () => this._logout());

    this.render(startHidden);
  }

  /**
   * Destroys the UI
   */
  destroy() {}

  doLogin() {
    this.auth0.getIdTokenClaims().then((token) => {
      this.core.setRequestOptions({
        headers: {
          authorization: `Bearer ${token.__raw}`,
        },
      });

      console.log('token', token.__raw);
      top['authToken'] = token.__raw;
      this.emit('login:post', {
        id: token.sub,
        username: token.email,
      });
    });
  }

  doLogout() {
    this.auth0.logout({ localOnly: false, returnTo: 'http://localhost:8000' });
  }

  /**
   * Renders the UI
   */
  render() {
    this.auth0options = this.core.config('auth0', {});
    let authConfig = Object.assign(
      {
        domain: 'YOUR_AUTH0_DOMAIN',
        client_id: 'YOUR_CLIENT_ID',
        response_type: 'token id_token',
        redirect_uri: 'http://localhost:8000',
      },
      this.auth0options
    );
    //  Object.assign(
    //   {
    //     domain: 'YOUR_AUTH0_DOMAIN',
    //     clientID: 'YOUR_CLIENT_ID',
    //     responseType: 'token id_token',
    //     scope: 'email profile openid',
    //     // audience: 'https://YOUR_AUDIENCE/',
    //     redirectUri: window.location.href,
    //   },
    //   this.core.config('auth0', {})
    // );

    createAuth0Client(authConfig)
      .then((auth0) => {
        this.auth0 = auth0;

        // const login = (authResult) => {
        //   const expiresAt = JSON.stringify(
        //     authResult.expiresIn * 1000 + new Date().getTime()
        //   );

        //   localStorage.setItem('isLoggedIn', 'true');
        //   localStorage.setItem('loginExpiration', expiresAt);

        //   this.core.setRequestOptions({
        //     headers: {
        //       authorization: `Bearer ${authResult.accessToken}`,
        //     },
        //   });

        //   this.emit('login:post', {
        //     id: authResult.idTokenPayload.sub,
        //     username: authResult.idTokenPayload.email,
        //   });
        // };

        this.auth0.isAuthenticated().then((isAuthenticated) => {
          if (isAuthenticated) {
            this.doLogout();
          } else {
            this.auth0
              .handleRedirectCallback()
              .then((authResult) => {
                this.doLogin();
              })
              .catch((error) => {
                this.auth0.loginWithRedirect();
              });
          }
        });
        // console.log(this.auth0.isAuthenticated);
        // this.auth0.isAuthenticated().then((isAuthenticated) => {
        //   console.log({ isAuthenticated });
        //   if (!isAuthenticated) {
        //     this.auth0
        //       .handleRedirectCallback()
        //       .then((authResult) => {
        //         console.log({ authResult });
        //         window.location.hash = '';
        //         // if (authResult && authResult.accessToken && authResult.idToken) {
        //         //   window.location.hash = '';
        //         //   login(authResult);
        //         // } else if (err) {
        //         //   console.error(err);
        //         //   alert(
        //         //     'Error: ' +
        //         //       err.error +
        //         //       '. Check the console for further details.'
        //         //   );
        //         // } else {
        //         //   this.auth0.loginWithRedirect();
        //         // }
        //       })
        //       .catch((error) => {
        //         console.error(error);
        //       });
        //   } else {
        //     this.auth0.getUser().then((user) => {
        //       console.log(user);
        //     });
        //   }
        // });

        // if (this._isAuthenticated()) {
        //   console.log(this._isAuthenticated());
        //   this._logout();

        //   this.auth0.loginWithRedirect();
        //   // this.webAuth.authorize();
        //   // webAuth.checkSession({}, (err, authResult) => {
        //   //   if (authResult && authResult.accessToken && authResult.idToken) {
        //   //     login(authResult);
        //   //   } else if (err) {
        //   //     console.error(err);

        //   //     this._logout();
        //   //   }

        //   //   // webAuth.authorize();
        //   // });
        // } else {
        //   console.log(this._isAuthenticated());

        //   console.log({ authResult });

        //   this.auth0.handleRedirectCallback().then((authResult) => {
        //     console.log({ authResult });
        //     if (authResult && authResult.accessToken && authResult.idToken) {
        //       window.location.hash = '';

        //       login(authResult);
        //     } else if (err) {
        //       console.error(err);

        //       alert(
        //         'Error: ' + err.error + '. Check the console for further details.'
        //       );
        //     } else {
        //       this.auth0.loginWithRedirect();
        //     }
        //   });
        // }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  _logout() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginExpiration');
    this.auth0.logout({
      client_id: this.auth0options.clientID,
      returnTo: window.location.href,
    });
  }

  _isAuthenticated() {
    const expiresAt = localStorage.getItem('loginExpiration');
    const expiration = parseInt(expiresAt, 10) || 0;

    return (
      localStorage.getItem('isLoggedIn') === 'true' &&
      new Date().getTime() < expiration
    );
  }
}
